// S2-FE2: VerdictBanner
import './VerdictBanner.css';

export interface VerdictBannerProps {
  verdict: 'READY' | 'NOT_READY' | 'CONDITIONAL';
  message: string;
  gatesPassed: number;
  gatesTotal: number;
}

export function VerdictBanner({ verdict, message, gatesPassed, gatesTotal }: VerdictBannerProps) {
  // Map verdict to CSS modifier
  const variantMap: Record<string, string> = {
    READY: 'ready',
    NOT_READY: 'not-ready',
    CONDITIONAL: 'conditional',
  };
  const variant = variantMap[verdict];

  return (
    <div className={`airgent-verdict airgent-verdict-${variant}`}>
      <div className="airgent-verdict-left">
        <div className={`airgent-verdict-text airgent-verdict-text-${variant}`}>
          {verdict.replace('_', ' ')}
        </div>
        <div className="airgent-verdict-message">{message}</div>
      </div>
      <div className="airgent-verdict-right">
        {gatesPassed}/{gatesTotal} passed
      </div>
    </div>
  );
}
